import { useState, useEffect } from 'react';

export interface SessionLog {
  id: string;
  timestamp: number;
  type: 'lifeline_query' | 'surah_read' | 'zakat_calc';
  input?: string; // What the user said/did
  outcome?: string; // Result summary (e.g., Surah name, Advice snippet)
  details?: any; // Full AI response, specific reasoning, etc.
}

export function useSessionLogger() {
  const [logs, setLogs] = useState<SessionLog[]>([]);

  useEffect(() => {
    const saved = localStorage.getItem('habl_session_logs');
    if (saved) {
      try {
        setLogs(JSON.parse(saved));
      } catch (e) {
        console.error('Failed to parse session logs', e);
      }
    }
  }, []);

  const logEvent = (entry: Omit<SessionLog, 'id' | 'timestamp'>) => {
    const newLog: SessionLog = {
      ...entry,
      id: crypto.randomUUID(),
      timestamp: Date.now(),
    };

    setLogs(prev => {
      const updated = [newLog, ...prev];
      localStorage.setItem('habl_session_logs', JSON.stringify(updated));
      return updated;
    });
  };

  const clearLogs = () => {
    setLogs([]);
    localStorage.removeItem('habl_session_logs');
  };

  return { logs, logEvent, clearLogs };
}
